module.exports = __webpack_public_path__ + "static/img/cixiu_6.e051eddf.jpg";